import { useState, useEffect, useMemo } from "react";
import { get, put } from "#api";

function useApiState(getEndpoint, putEndpoint) {
  const [apiState, setApiState] = useState(null);
  const [state, setState] = useState(null);

  const getState = async () => {
    const data = await get(getEndpoint);
    setApiState(data);
    setState(data);
  };

  useEffect(() => {
    getState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const submit = async () => {
    const result = await put(putEndpoint, state);
    if (result) {
      setApiState(result);
      setState(result);
    } else {
      // TODO toaster
    }
  };
  const reset = () => {
    setState(apiState);
  };

  const isChanged = useMemo(() => {
    return JSON.stringify(apiState) !== JSON.stringify(state);
  }, [apiState, state]);

  return {
    onChange,
    state,
    submit,
    reset,
    isChanged,
  };
}
export default useApiState;
